import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, Typography, Button } from '@mui/material';
// utils
import { bgBlur } from '../../utils/cssStyles';
// components
import Logo from '../logo';
// ----------------------------------------------------------------------

const NAV_WIDTH = 0;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

export default function SignatureHeader(props) {

  const navigate = useNavigate();

  const handleTokenRquest = async () => {

    if (props.envelope?.signature_type === 'icp' && props.onAssinarClick) {
      props.onAssinarClick();
      return;
    }

    if (props.envelope?.signature_type === 'icp') {
      navigate(`/signature/${props.signerKey}/icp`);
    } else {
      // a tela de confirmação pede o token e mostra canal, contagem e erros (TokenChallenge)
      navigate(`/signature/${props.signerKey}/token`, { state: { requestToken: true } });
    }

  }

  return (
    <StyledRoot>
      <StyledToolbar>
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={{
              xs: 0.5,
              sm: 1,
            }}
            sx={{ 
              flex: 1,
              minWidth: 0,
              overflow: 'hidden'
            }}
          >
        <Logo/>
        <Typography 
          variant="h4" 
          gutterBottom={false}
          color="common.black"
          sx={{
            fontSize: { xs: '0.875rem', sm: '1rem', md: '1.5rem' },
            fontWeight: { xs: 500, md: 600 },
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: { xs: 'none', sm: 'block' },
            ml: { xs: 0.5, sm: 1 }
          }}
        >
              Envelope: {props.envelope ? props.envelope.envelope_name : '...'}
        </Typography>
        <Typography 
          variant="body2" 
          color="common.black"
          sx={{
            fontSize: '0.75rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: { xs: 'block', sm: 'none' },
            ml: 0.5
          }}
        >
              {props.envelope ? props.envelope.envelope_name : '...'}
        </Typography>
        </Stack>
        <Box sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
            {/* Esconder botão Assinar se for observer e não estiver autenticado */}
            {!(props.isObserver && !props.isAuthenticated) && (
              <Button 
                  variant="contained"
                  onClick={_ => handleTokenRquest()}
                  sx={{
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                    px: { xs: 1.5, sm: 2 },
                    py: { xs: 0.5, sm: 1 },
                    minHeight: { xs: '32px', sm: '36.5px' }
                  }}>
                  Assinar
              </Button>
            )}
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
